export default {"src":"https://s.sylndr.com/c-1ab3f05/_next/static/media/LogoutBlack.1604f9db.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};